// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3WPjk","header":"Messages_header__1486y"};